export default {
  props: {
    isCreatorV3: {
      type: Boolean,
      default: false,
    },
  },
};
